import { Component, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { ISnackBarDataModel } from './toaster.model';

@Component({
  standalone: true,
  imports: [NgClass],
  selector: 'app-snack-bar',
  template: `
    <span data-test="toaster-message">
      <i class="pr-1" data-test="toaster-icon" [ngClass]="data.icon"></i> {{ data.message }}
    </span>
  `,
})
export class ToasterComponent {
  public data: ISnackBarDataModel = inject(MAT_SNACK_BAR_DATA);
}
